<template>
    <div class="offscreen__menu" :class="toggle ? 'open' : ''">
        <b-modal centered hide-footer id="userProfileModal" :title="userProfileTitle">
            <UserProfileModal ref="refUserProfileModal" />
        </b-modal>
        <div class="top-section">
            <div class="user__initials">
                <div class="logged-in-user">
                    {{ userName | textInitials }}
                </div>
            </div>
            <span class="fullname">
                {{ userName }}
            </span>
        </div>
        <div class="secondary-menu">
            <ul>
                <li>
                    <a href="#" @click="$bvModal.show('userProfileModal')">
                        <i class="fas fa-fw fa-cog"></i>
                        My Account
                    </a>
                </li>
                <li>
                    <a href="#" @click="$bvModal.show('feedbackModal')">
                        <i class="fas fa-fw fa-question"></i>
                        Feedback
                    </a>
                </li>
                <li>
                    <a href="#" @click.prevent="logout">
                        <i class="fas fa-fw fa-sign-out-alt"></i>
                        Logout
                    </a>
                </li>
            </ul>
        </div>
        <div class="bottom-section">
            Workflow
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserProfileModal from "./UserProfileModal";
export default {
    props: ['toggle', 'userName'],
    components: {
        UserProfileModal
    },
    data() {
        return {
            userProfileTitle: 'My Account'
        }
    },
    mounted() {
        this.getPreference();
        this.getPreferenceDeliverableTypes();
        this.$store.dispatch("fetchAllRoles");
        this.$root.$on('logout', this.logout);
        this.$root.$on('userProfileTitleChange', this.changeUserProfileTitle);
    },
    methods: {
        ...mapActions(['getPreference', 'getPreferenceDeliverableTypes']),
        logout() {
            if($('#update-logout').length) {
                let alertId = $('#update-logout').data('alertid');
                this.$store.dispatch('makeAlertRead', {alert: {id: alertId, loggedout: 'true'}});
            }
            this.$store.dispatch("logout").then(() => this.$router.push("/login"));
        },
        changeUserProfileTitle(args) {
            if (args.enablePasswordEdit) {
                this.userProfileTitle = "Change Password";
            } else {
                this.userProfileTitle = "My Account";
            }
        },
    }
}
</script>